import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import Header from "../../components/Header";
import "./PageTemplate.scss";

export const PageTemplate = ({
    isHiddenMenu,
    sideBar,
    children,
    className,
    classNameContent,
    classNameContentInner
}) => (
    <>
        <Header isHiddenMenu={isHiddenMenu} />

        <div className={classNames("main-box", className)}>
            { sideBar }

            <div className={classNames("content-box", classNameContent)}>
                { children && <div className={classNames("content-box__inner", classNameContentInner)}>{ children }</div> }
            </div>
        </div>
    </>
);

PageTemplate.propTypes = {
    isHiddenMenu: PropTypes.bool,
    Header: PropTypes.node,
    sideBar: PropTypes.node,
    children: PropTypes.node
};

PageTemplate.defaultProps = {
    isHiddenMenu: false,
    sideBar: null,
    Header: null,
    footer: null,
    children: null
};
